import { useTranslations } from '@vocab/react';
import { Box, Stack } from 'braid-design-system';
import { forwardRef, useMemo, type ComponentProps } from 'react';

import translations from './.vocab';
import { CareerFeedAIHeading } from './CareerFeedAIHeading';
import { useCareerFeedAIAssistant } from './hooks/useCareerFeedAIAssistant';

import * as styles from './CareerFeedAIAssistantContainer.css';

const useWidgetHeading = () => {
  const { progress } = useCareerFeedAIAssistant();
  const { t } = useTranslations(translations);

  return useMemo(() => {
    switch (progress) {
      case 'initial':
      case 'gatheringRefinement':
      case 'collectGeneralRequirementsAtLast':
        return t('Want better job matches?');
      case 'recsRefined':
      case 'recsRefined-withPersistedData':
        return t('Refined for you');
    }
  }, [progress, t]);
};

interface CareerFeedAIAssistantWidgetProps {
  showHeading?: boolean;
  children: ComponentProps<typeof Stack>['children'];
}
export const CareerFeedAIAssistantWidget = forwardRef<
  HTMLDivElement,
  CareerFeedAIAssistantWidgetProps
>(({ showHeading, children }, ref) => {
  const headingText = useWidgetHeading();

  return (
    <Box
      display="flex"
      flexDirection="column"
      width="full"
      paddingY="medium"
      ref={ref}
    >
      <Stack space="xxsmall">
        {showHeading && (
          <CareerFeedAIHeading headingText={headingText} betaBadge />
        )}
        <Box className={styles.quoteBlock}>{children}</Box>
      </Stack>
    </Box>
  );
});
